import { ACTIONS } from '../constants/invoice-rows';

const INITIAL_STATE = {
  rowsList: { rows: [], params: {}, pager: null, loading: false, error: null },
  activeRow: { row: null, loading: false, error: null },
};

export const invoiceRows = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    /* ---------- LIST FETCH ---------- */
    case ACTIONS.INVOICE_ROWS_FETCH_START:
      return {
        ...state,
        rowsList: { ...state.rowsList, loading: true, error: null, params: action.payload || {} },
      };

    case ACTIONS.INVOICE_ROWS_FETCH_SUCCESS:
      return {
        ...state,
        rowsList: {
          ...state.rowsList,
          rows: action.payload.results,
          pager: action.payload.paginator,
          loading: false,
          error: null,
        },
      };

    case ACTIONS.INVOICE_ROWS_FETCH_FAILURE:
      return {
        ...state,
        rowsList: { ...state.rowsList, loading: false, error: action.payload },
      };

    /* ---------- SINGLE FETCH ---------- */
    case ACTIONS.INVOICE_ROW_FETCH_START:
      return { ...state, activeRow: { row: null, loading: true, error: null } };

    case ACTIONS.INVOICE_ROW_FETCH_SUCCESS:
      return { ...state, activeRow: { row: action.payload, loading: false, error: null } };

    case ACTIONS.INVOICE_ROW_FETCH_FAILURE:
      return { ...state, activeRow: { row: null, loading: false, error: action.payload } };

    /* ---------- CREATE / UPDATE / DELETE ---------- */
    case ACTIONS.INVOICE_ROW_CREATE_START:
    case ACTIONS.INVOICE_ROW_UPDATE_START:
    case ACTIONS.INVOICE_ROW_DELETE_START:
      return {
        ...state,
        activeRow: { ...state.activeRow, loading: true, error: null, successMessage: null },
      };

    case ACTIONS.INVOICE_ROW_CREATE_SUCCESS:
      return {
        ...state,
        rowsList: { ...state.rowsList, rows: [...state.rowsList.rows, action.payload] },
        activeRow: {
          row: action.payload,
          loading: false,
          error: null,
          successMessage: 'APP.INVOICE_ROW.SUCCESS-ADD',
        },
      };

    case ACTIONS.INVOICE_ROW_UPDATE_SUCCESS:
      return {
        ...state,
        rowsList: {
          ...state.rowsList,
          rows: state.rowsList.rows.map(r => (r.id === action.payload.id ? action.payload : r)),
        },
        activeRow: {
          row: action.payload,
          loading: false,
          error: null,
          successMessage: 'APP.INVOICE_ROW.SUCCESS-EDIT',
        },
      };

    case ACTIONS.INVOICE_ROW_DELETE_SUCCESS:
      return {
        ...state,
        rowsList: {
          ...state.rowsList,
          rows: state.rowsList.rows.filter(r => r.id !== action.payload.id),
        },
        activeRow: {
          row: null,
          loading: false,
          error: null,
          successMessage: 'APP.INVOICE_ROW.SUCCESS-DELETE',
        },
      };

    case ACTIONS.INVOICE_ROW_CREATE_FAILURE:
    case ACTIONS.INVOICE_ROW_UPDATE_FAILURE:
    case ACTIONS.INVOICE_ROW_DELETE_FAILURE:
      return {
        ...state,
        activeRow: {
          ...state.activeRow,
          loading: false,
          error: action.payload,
          successMessage: null,
        },
      };

    /* ---------- RESET ---------- */
    case ACTIONS.INVOICE_ROW_RESET:
      return { ...state, activeRow: { row: null, loading: false, error: null } };

    default:
      return state;
  }
};
